import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components'
import { Link, withRouter } from 'react-router-dom'
import { rgba } from 'polished'
import { filter, find } from 'lodash'
import queryString from 'qs';
import Highlighter from "react-highlight-words";
import lunr from 'lunr'
import LazyLoad from 'react-lazy-load';
import { LazyImageFull, ImageState } from "react-lazy-images";
import { CSSTransitionGroup } from 'react-transition-group';

import { isClient } from '../../utils'
import { fetchChapters, getChapters } from '../Chapters/redux'
import { updateSettings } from '../../settings'
import { fetchMedia, getMedia } from '../../media'
import { fetchData } from '../../api'

import { Attachment } from '../../components'
import { media } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding, bgIcon } from '../../styles/global';

let FadeImage;

if (isClient()) {
    FadeImage = require('react-fade-image').default;
}

class Search extends Component {

    constructor(props) {
        super(props);
        this.totalCount = React.createRef();
    }

    state = {
        query: '',
        totalResultsCount: 0,
    }

    componentWillMount = () => {
        const { updateSettings } = this.props;

        this.props.fetchMedia();

        updateSettings({
            pageTitle: 'Search'
        })
    }
    
    componentDidMount = () => {
        const { location, fetchMedia } = this.props;
        
        if (location.search !== '') {
            const search = queryString.parse(location.search);
            this.setState({
                query: search['?query'],
            })
        }

        fetchData('searchIndex/get/mediaIndex')
            .then(response => {
                this.setState({
                    mediaIndex: lunr.Index.load(response)
                })
            })

        fetchData('searchIndex/get/chapterIndex')
            .then(response => {
                this.setState({
                    chapterIndex: lunr.Index.load(response)
                })
            })

        fetchData('searchIndex/get/textBlockIndex')
            .then(response => {
                this.setState({
                    textBlocksIndex: lunr.Index.load(response)
                })
            })
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { location } = this.props;
        
        if (location.search !== '' && location.search !== prevProps.location.search) {
            const search = queryString.parse(location.search);
            
            this.setState({
                query: search['?query'],
            })
        }
    }

    refsToArray = (refs) => {
        let refsArray = []

        refs.forEach((ref) => {
            refsArray.push(parseInt(ref.ref))
        })

        return refsArray;
    }

    textRefsToArray = (refs) => {
        let refsArray = []

        refs.forEach((ref) => {
            let splitRef = ref.ref.split("|");

            refsArray.push({
                post: parseInt(splitRef[0]),
                block: parseInt(splitRef[1]),
            })
        })

        return refsArray;
    }

    getSectionTitle = (parentID) => {
        const { chapters } = this.props;
        const parent = find(chapters.data, {id: parentID});

        if (parent) {
            return parent.title
        }
    }

    getTagString = (tags) => {
        let tagString = ''; 

        if (tags && tags.length) {
            tags.forEach((tag) => {
                tagString = `${tagString !== '' ? `${tagString},` : ''} ${tag.name}`
            })
        }
        
        return tagString
    }

    renderResultCount = () => {
        const { query, chapterIndex, mediaIndex, textBlocksIndex } = this.state;

        if (chapterIndex && mediaIndex && textBlocksIndex) {

            let totalCount = 0;

            if (query) {
                const chapterCount = this.refsToArray(chapterIndex.search(`title:${query}~1`)).length;
                const textBlockCount = this.textRefsToArray(textBlocksIndex.search(`content:${query}~1`)).length;
                const mediaCount = this.refsToArray(mediaIndex.search(`name:${query}~1`)).length;
                const tagCount = this.refsToArray(chapterIndex.search(`tags:${query}~1`)).length;
                totalCount = (chapterCount + textBlockCount + mediaCount + tagCount);
            }

            return (
                <ResultsCount>
                    <Count>
                        {totalCount}
                    </Count>
                    {`results found for ‘${query}’`}
                </ResultsCount>
            )
        }
    }
    
    searchPages = () => {
        const { chapterIndex, query } = this.state;
        const { chapters } = this.props;

        if (chapterIndex && query && chapters) {
            const matchedRefs = this.refsToArray(chapterIndex.search(`title:${query}~1`));
            
            const refs = filter(chapters.data, function(o) {
                if (o.type == "child" && matchedRefs.includes(o.id)) {
                    return true
                }
            });
            
            if (refs.length) {
                const results = refs.map((res, i) => {
                    return (
                        <PageResult
                            key={i}
                            to={`/chapter/${res.slug}`}
                        >
                            <Section>{this.getSectionTitle(res.parent_id)} /</Section>
                            <Highlighter
                                highlightClassName="bold"
                                searchWords={[query]}
                                autoEscape={true}
                                textToHighlight={res.title}
                            />
                        </PageResult>
                    )
                })

                return this.renderResultsGroup('Pages', results)
            }
        }
    }

    searchTextBlocks = () => {
        const { textBlocksIndex, query } = this.state;
        const { chapters } = this.props;

        if (textBlocksIndex && query && chapters) {
            const matchedRefs = this.textRefsToArray(textBlocksIndex.search(`content:${query}~1`));

            let blocks = [];

            matchedRefs.forEach((ref) => {
                const chapter = find(chapters.data, {id: ref.post});

                if (chapter) {
                    const content = chapter.blocks[ref.block].content;
                    const block = chapter.blocks[ref.block]
                    if (block.content) {
                        blocks.push({
                            title: chapter.title,
                            slug: chapter.slug,
                            parentID: chapter.parent_id,
                            content: content.replace(/<(?:.|\n)*?>/gm, ''),
                        })
                    }
                }
            })
            
            if (blocks.length) {
                const results = blocks.map((block, i) => {
                    return (
                        <React.Fragment>
                            <PageResult
                                key={i}
                                to={`/chapter/${block.slug}`}
                            >
                                <Section>{this.getSectionTitle(block.parentID)} /</Section>
                                
                                <Highlighter
                                    highlightClassName="bold"
                                    searchWords={[query]}
                                    autoEscape={true}
                                    textToHighlight={block.title}
                                />
                            </PageResult>

                            <BlockContent>
                                <Highlighter
                                    highlightClassName="bold"
                                    searchWords={[query]}
                                    autoEscape={true}
                                    textToHighlight={block.content}
                                />
                            </BlockContent>
                        </React.Fragment>
                    )
                })

                return this.renderResultsGroup('In Text', results)
            }
        }
    }

    searchMedia = () => {
        const { mediaIndex, query } = this.state;
        const { media } = this.props;

        if (mediaIndex && query && media && media.data) {
            const matchedRefs = this.refsToArray(mediaIndex.search(`name:${query}~1`));

            const refs = filter(media.data.data, function(o) {
                if (matchedRefs.includes(o.post.ID)) {
                    return true
                }
            });
            
            if (refs.length) {
                const images = refs.map((image, i) => {
  
                    const src = `${image.path}${image.meta.sizes.medium.file}`;
                    
                    return (
                        <ImageResult
                            key={i}
                        >
                            {isClient() && (
                                <FadeImage 
                                    width={189}
                                    height={126}
                                    src={src} 
                                />
                            )} 

                            <Title>
                                <Highlighter
                                    highlightClassName="bold"
                                    searchWords={[query]}
                                    autoEscape={true}
                                    textToHighlight={image.meta.sizes.medium.file}
                                />
                            </Title>
                        </ImageResult>
                    )
                })

                const results = <Grid>{images}</Grid>

                return this.renderResultsGroup('Media', results, images)
            }
        }
    }

    searchTags = () => {
        const { chapterIndex, query } = this.state;
        const { chapters } = this.props;

        if (chapterIndex && query && chapters) {
            const matchedRefs = this.refsToArray(chapterIndex.search(`tags:${query}~1`));
            
            const refs = filter(chapters.data, function(o) {
                if (o.type == "child" && matchedRefs.includes(o.id)) {
                    return true
                }
            });
            
            if (refs.length) {
                const results = refs.map((res, i) => {
                    return (
                        <React.Fragment>
                            <PageResult
                                key={i}
                                to={`/chapter/${res.slug}`}
                            >
                                <Section>{this.getSectionTitle(res.parent_id)} /</Section>
                                {res.title}
                            </PageResult>
                            <Tags>
                                Tag:
                                <Highlighter
                                    highlightClassName="bold"
                                    searchWords={[query]}
                                    autoEscape={true}
                                    textToHighlight={this.getTagString(res.tags)}
                                />
                            </Tags>
                        </React.Fragment>
                    )
                })

                return this.renderResultsGroup('Tags', results)
            }
        }
    }
    
    renderResultsGroup = (title, results, count) => { 
        return (
            <ResultsGroup>
                <Title>
                    {title}
                    <Count>({count ? count.length : results.length})</Count>
                </Title>  
                <Results>{results}</Results>
            </ResultsGroup>
        )
    }
      
    render() {
        return (
            <Container
                className="overflow-wrapper"
            >
                {this.renderResultCount()}
                {this.searchPages()} 
                {this.searchTextBlocks()} 
                {this.searchMedia()} 
                {this.searchTags()} 
            </Container>
        )
    }
}

const Container = styled.div`
    flex: 1;
    overflow-y: scroll;
    height: calc(100vh - 65px); 
    position: relative;

    ${media.phone`
        height: calc(100vh - 49px); 
    `}
`

const Title = styled.div`
    display: flex;
`

const Count = styled.div`
    color: #9C9B8F;
    margin-left: 8px;
`

const ResultsCount = styled.div`
    display: flex;
    ${padding}
    align-items: center;
    height: 57px;
    min-height: 57px;
    border-bottom: 1px solid black;

    ${Count} {
        color: black;
        margin-right: 4px;
        margin-left: 0;
    }
`

const ResultsGroup = styled.div`
    display: flex;
    ${padding}
    padding-top: 25px;
    padding-bottom: 80px;
    flex: 1 0 auto;

    &:not(:last-child) {
        border-bottom: 1px solid black;
    }

    ${Title} {
        flex: 0 1 240px;
        font-size: 24px;
    }

    ${media.phone`
        flex: 1 0 auto;
        flex-direction: column;
        padding-bottom: 24px;
        padding-top: 8px;

        ${Title} {
            flex: 0 1 auto;
            margin-bottom: 6px;
            font-size: 22px;
        }
    `}
`

const Results = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    .bold {
        background: none;
        font-weight: bold;
    }
`

const PageResult = styled(Link)`
    display: flex;
    font-size: 24px;

    ${media.phone`
        font-size: 16px;
    `}
`

const Section = styled.div`
    color: #9C9B8F;
    margin-right: 6px;
`

const BlockContent = styled.div`
    margin-top: 4px;
    margin-bottom: 48px;

    ${media.phone`
        margin-top: 4px;
        margin-bottom: 24px;
    `}
`

const Tags = styled.div`
    margin-bottom: 26px;
`

const ImageResult = styled.div`
    display: flex;
    font-size: 24px;

    >:first-child {
        padding-bottom: 0 !important;
        margin-bottom: 7px;
        height: 126px;
    }

    img {
        max-height: 126px;
        width: auto;
        height: 100%;
    }

    ${Title} {
        font-size: 16px;
        flex: 0;
    }
`

const Grid = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: calc(100% + 17px);
    padding: 13px;
    padding-top: 8px;
    box-sizing: border-box;
    flex: 1;
    max-width: 1280px;

    > * {
        display: flex;
        flex-direction: column;
        flex: 0 1;
        flex-basis: calc(33.3% - 17px);
        margin-right: 17px;
        margin-bottom: 30px;

        ${media.phone`
            flex-basis: calc(100% - 17px);
        `}
    }

    ${media.phone`
        padding-left: 0;
    `}
`

injectGlobal`
    .example-enter {
        opacity: 0.01;
    }

    .example-enter.example-enter-active {
        opacity: 1;
        transition: opacity 500ms ease-in;
    }

    .example-leave {
        opacity: 1;
    }

    .example-leave.example-leave-active {
        opacity: 0.01;
        transition: opacity 300ms ease-in;
    }
`

const mapDispatchToProps = dispatch => ({
    fetchMedia() {
        dispatch(fetchMedia())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    chapters: getChapters(state),
    media: getMedia(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));



// WEBPACK FOOTER //
// ./client/modules/Search/Search.js